"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var XIcon = function (props) {
    var _a = props.color, color = _a === void 0 ? helios_styles_1.icon.default : _a, rest = __rest(props, ["color"]);
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0, jsx_runtime_1.jsx)("mask", __assign({ id: "mask0_7300_6876", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "16", height: "16" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M4 4.00002L12.5161 12.5161M4 12.5161L12.5161 4", stroke: "#475569", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })), (0, jsx_runtime_1.jsx)("g", __assign({ mask: "url(#mask0_7300_6876)" }, { children: (0, jsx_runtime_1.jsx)("rect", { width: "16", height: "16", fill: color }) }))] })));
};
exports.XIcon = XIcon;
